<template>
    <v-container>
        <div class="top_menubar mb-4">
            <v-tabs stacked color="light-green" variant="" >
                <v-tab :to="{name: 'Messages'}" prepend-icon="announcement">
                    <span v-if="isNotMobile" class="mt-2">{{ $t('warnings.warnings') }} </span>
                </v-tab>
                <v-tab :to="{name: 'WarningsStatistics'}" prepend-icon="insights">
                    <span v-if="isNotMobile" class="mt-2">{{ $t('warnings.statistics') }}</span>
                </v-tab>
            </v-tabs>
        </div>
        <v-row>
            <v-col>
                <router-view/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: "WarningsPortal",

    computed: {
        isNotMobile() {
            return !this.$vuetify.display.xs;
        }
    }
}
</script>

<style scoped>

.top_menubar {
    border-bottom: 2px solid #c4c4c4;
}

</style>
